import React from 'react';
import { oneOf, string } from 'prop-types';
//styles
import { AvatarWrapper } from './style';

export const ProfileAvatar = ({ src, size, ...props }) => (
    <AvatarWrapper size={size}>
        <img src={src} alt={'Avatar'} />
    </AvatarWrapper>
);

ProfileAvatar.propTypes = {
    size: oneOf(['small', 'medium', 'large', 'customSize', '_base']),
    src: string.isRequired,
};

ProfileAvatar.defaultProps = {
    size: 'small',
};



// WEBPACK FOOTER //
// ./src/UI/Components/ProfileAvatar/ProfileAvatar.js